export class Bijection<K, V> {
  private _direct = new Map<K, V>();
  private _inverse = new Map<V, K>();

  set(k: K, v: V) {
    this._direct.set(k, v);
    this._inverse.set(v, k);
  }

  has(k: K) {
    return this._direct.has(k);
  }

  get(k: K): V|undefined {
    return this._direct.get(k);
  }

  inverse(v: V): K|undefined {
    return this._inverse.get(v);
  }
}
